import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function Terms() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-canvas">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <Button 
          variant="ghost" 
          onClick={() => navigate(-1)}
          className="mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour
        </Button>

        <h1 className="text-4xl font-bold text-ink mb-8">Conditions Générales d'Utilisation</h1>
        
        <div className="prose prose-zinc max-w-none">
          <p className="text-lg text-ink-muted mb-8">
            Dernière mise à jour : Février 2026
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-ink mb-4">1. Présentation du Service</h2>
            <p className="text-ink-muted mb-4">
              Ema est une plateforme SaaS de pré-qualification RH utilisant l'intelligence artificielle 
              pour mener des entretiens autonomes. Le service est fourni par Proprio Technologie.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-ink mb-4">2. Acceptation des Conditions</h2>
            <p className="text-ink-muted mb-4">
              En utilisant Ema, vous acceptez les présentes conditions générales d'utilisation. 
              Si vous n'acceptez pas ces conditions, vous ne devez pas utiliser le service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-ink mb-4">3. Compte Utilisateur</h2>
            <ul className="list-disc pl-6 text-ink-muted space-y-2">
              <li>Vous devez fournir des informations exactes lors de l'inscription</li>
              <li>Vous êtes responsable de la confidentialité de vos identifiants</li>
              <li>Un compte correspond à une entreprise ou un particulier</li>
              <li>L'utilisation de plusieurs comptes pour contourner les limites est interdite</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-ink mb-4">4. Utilisation de l'IA</h2>
            <p className="text-ink-muted mb-4">
              Notre système d'IA (Ema) est conçu pour évaluer objectivement les candidats. Cependant :
            </p>
            <ul className="list-disc pl-6 text-ink-muted space-y-2">
              <li>L'IA ne remplace pas le jugement humain final</li>
              <li>Les scores et recommandations sont indicatifs</li>
              <li>Nous travaillons activement à réduire les biais algorithmiques</li>
              <li>Les décisions d'embauche restent de votre responsabilité</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-ink mb-4">5. Crédits et Paiements</h2>
            <ul className="list-disc pl-6 text-ink-muted space-y-2">
              <li>3 crédits gratuits sont offerts à l'inscription (mode essai)</li>
              <li>Les crédits sont consommés uniquement après un entretien complété</li>
              <li>Les crédits non utilisés ne sont pas remboursables</li>
              <li>Les tarifs peuvent être modifiés avec un préavis de 30 jours</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-ink mb-4">6. Enregistrement Vidéo</h2>
            <p className="text-ink-muted mb-4">
              Le service enregistre les 2 premières minutes de chaque entretien vidéo. 
              Le consentement du candidat est obligatoire avant l'enregistrement.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-ink mb-4">7. Propriété Intellectuelle</h2>
            <p className="text-ink-muted mb-4">
              Ema, son logo, et l'ensemble du contenu de la plateforme sont la propriété 
              de Proprio Technologie. Toute reproduction est interdite sans autorisation.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-ink mb-4">8. Limitation de Responsabilité</h2>
            <p className="text-ink-muted mb-4">
              Proprio Technologie ne peut être tenu responsable des décisions d'embauche 
              basées sur les évaluations d'Ema. Le service est fourni "tel quel".
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-ink mb-4">9. Modifications</h2>
            <p className="text-ink-muted mb-4">
              Nous nous réservons le droit de modifier ces conditions à tout moment. 
              Les utilisateurs seront informés des modifications significatives par email.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-ink mb-4">10. Contact</h2>
            <p className="text-ink-muted">
              Pour toute question concernant ces conditions, contactez-nous à : 
              <a href="mailto:legal@ema.ai" className="text-brand-primary hover:underline ml-1">
                legal@ema.ai
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
